import WidgetCard from "@/components/cards/widget-card";
import ControlledTable from "@/components/controlled-table";
import { addShipment } from "@/server/api-services";
import { Order, OrderStatus, Shipment } from "@/types";
import cn from "@/utils/class-names";
import toast from "react-hot-toast";
import { AddShipmentModal } from "./add-Modal";
import { PiEmptyThin } from "react-icons/pi";
import { AuthContext } from "@/auth/authContext";
import { useContext } from "react";
import { permissions } from "../../roles-permissions/permissions";

interface DeliveryDetailsProps {
    order: Order;
    refresh: () => void;
}

export const getColumns = () => [
    {
        title: <span className="block">Tracking Number</span>,
        dataIndex: "trackingNumber",
        key: "trackingNumber",
        width: 300,
        render: (trackingNumber: string) => <p>{trackingNumber}</p>,
    },
    {
        title: <span className="block">Estimated Delivery Date</span>,
        dataIndex: "estimatedDeliveryDate",
        key: "estimatedDeliveryDate",
        width: 300,
        render: (estimatedDeliveryDate: string) => (
            <p>{new Date(estimatedDeliveryDate).toLocaleDateString()}</p>
        ),
    },
    {
        title: <span className="block">shipmentProvider</span>,
        dataIndex: "shipmentProvider",
        key: "shipmentProvider",
        width: 200,
        render: (shipmentProvider: string) => <p>{shipmentProvider}</p>,
    },
    {
        title: <span className="block">shippingDate</span>,
        dataIndex: "shippingDate",
        key: "shippingDate",
        width: 200,
        render: (shippingDate: string) => (
            <p>{new Date(shippingDate).toLocaleDateString()}</p>
        ),
    },
    {
        title: <span className="ms-6 block">Cost</span>,
        dataIndex: "shippingCost",
        key: "shippingCost",
        width: 100,
        render: (shippingCost: number) => (
            <span className="ms-6 bold">
                <strong>${shippingCost}</strong>
            </span>
        ),
    },
];

export default function ShippingDetails({
    order: orders,
    refresh,
}: DeliveryDetailsProps) {
    const { role } = useContext(AuthContext);
    async function registerShipment(shipment: Shipment) {
        const response = await addShipment(orders.id, shipment);
        if (response.statusCode !== 200) {
            toast.error("Failed to add track");
            return;
        }
        refresh();
    }

    return (
        <div className={cn("w-full")}>
            <WidgetCard
                title="Shipping Details"
                className={cn("flex flex-col")}
                headerClassName="widget-card-header flex-col sm:flex-row"
                action={
                    role &&
                    (role.includes(permissions.transactions.addTransaction) ||
                        role.includes(permissions.system.admin)) && (
                        <AddShipmentModal
                            show={orders.status !== OrderStatus.Purchased}
                            handleSave={registerShipment}
                            title="Add Tracking"
                            description="Add a new track to the order"
                        />
                    )
                }
            >
                <div className={cn("table-wrapper flex-grow-mx-5 lg:-mx-7")}>
                    {orders.trackingNumber != null &&
                    orders.shipmentProvider != null ? (
                        <ControlledTable
                            data={[orders]}
                            columns={getColumns()}
                            scroll={{ x: "100%", y: 240 }}
                            sticky={true}
                            variant="modern"
                            className="mt-4"
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center">
                            <PiEmptyThin className="h-8 w-8 text-gray-400" />
                            <p>No shipment details</p>
                        </div>
                    )}
                </div>
            </WidgetCard>
        </div>
    );
}
